let lockCount = 0
let scrollTop = 0

export function useScrollLockForModal() {
  const $route = useRoute()
  onMounted(() => {
    lockCount++
    if (lockCount === 1) {
      scrollTop = window.scrollY
      const html = document.documentElement

      html.style.position = 'fixed'
      html.style.top = `-${scrollTop}px`
      html.style.left = '0'
      html.style.right = '0'
      html.style.width = '100%'
    }
  })

  onUnmounted(() => {
    lockCount--
    if (lockCount === 0) {
      const html = document.documentElement

      html.style.top = ''
      html.style.left = ''
      html.style.right = ''
      html.style.position = ''
      html.style.width = ''

      window.scrollTo(0, scrollTop)
    }
  })
  watch(
    () => $route.path,
    () => {
      scrollTop = 0
      const html = document.documentElement
      html.style.top = `0`
    },
  )
}
